import script from "./MapControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapControls.vue?vue&type=script&setup=true&lang=ts"

import "./MapControls.vue?vue&type=style&index=0&id=55824eac&lang=less"

const __exports__ = script;

export default __exports__